<script lang="ts" setup>
import CategoryLauncherFullWidth from './CategoryLauncherFullWidth.vue';
import CategoryLauncher from '@/components/CategoryLauncher.vue'
import MissingImageCategoryLaunchers from '@/components/MissingImageCategoryLaunchers.vue';
import {  computed } from 'vue'
import { storeToRefs } from 'pinia';
import { useCategoryLandingStore } from '@/store/categoryLandingStore';


let { launcherCategories, missingImages } = storeToRefs(useCategoryLandingStore());

let defaultColumns = computed(() => {
    let categoryCount = launcherCategories.value.length
    if(categoryCount % 4 == 0){
        return 'four'
    } else if(categoryCount % 3 == 0){
        return 'three'
    } else if(categoryCount % 2 == 0){
        return 'two'
    } else {
        return 'four'
    }
})
let props = defineProps({
    textBelow: {
        type: Boolean,
        default: false
    },
    columns: {
        type: String,
        required: false
    },
    isFullWidth: {
        type: Boolean,
        default: false
    },
    useGradient: {
        type: Boolean,
        default: false
    },
    gradientColor: {
        type: String,
        default: 'rothcoBlack'
    },
    togglePadding: {
        type: Boolean,
        default: false
    },
})

let bindProperties = computed(()=>{
    if(missingImages.value){
        return {
            categories: launcherCategories.value,
            missingImages: missingImages.value,
            'text-below': props.textBelow,
            columns: props.columns ? props.columns : defaultColumns.value,
            is: MissingImageCategoryLaunchers,
            togglePadding: props.togglePadding
        }
    } else if(props.isFullWidth){
        let launcherRows = []
        //split the categories into rows based on the columns. Default should be 3 per row
        switch(props.columns){
            case 'two':
                
                    launcherRows = launcherCategories.value.reduce((acc, category, index) => {
                        if(index % 2 == 0){
                            acc.push({
                                launcherItems: [category]
                            })
                        } else {
                            acc[acc.length - 1].launcherItems.push(category)
                        }
                        return acc
                    }, []);
                break;
            case 'four':
                launcherRows = launcherCategories.value.reduce((acc, category, index) => {
                        if(index % 4 == 0){
                            acc.push({
                                launcherItems: [category]
                            })
                        } else {
                            acc[acc.length - 1].launcherItems.push(category)
                        }
                        return acc
                    }, []);
                    break;
            default:
                    launcherRows = launcherCategories.value.reduce((acc, category, index) => {
                        if(index % 3 == 0){
                            acc.push({
                                launcherItems: [category]
                            })
                        } else {
                            acc[acc.length - 1].launcherItems.push(category)
                        }
                        return acc
                    }, [])
               
        }
        return {
            launcherRows,
            is: CategoryLauncherFullWidth,
            use_gradient: props.useGradient,
            gradient_color: props.gradientColor,
            togglePadding: props.togglePadding
        }
    } else {
        return {
            categories: launcherCategories.value,
            'text-below': props.textBelow,
            columns: props.columns ? props.columns : defaultColumns.value,
            is: CategoryLauncher,
            togglePadding: props.togglePadding
        }
    }
})

</script>
<template>
    <component :is="bindProperties.is" v-bind="bindProperties"/>
</template>